module.exports = __webpack_public_path__ + "static/img/loading-1-fr.6e2a79c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/load/img/loading-1-fr.png
// module id = qHGE
// module chunks = 1